// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1JADS","list":"styles_list__3qYf4"};